import React, { useEffect } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useNavigate } from 'react-router-dom'
import './Login.css'
import Login from './Login'
import Register from './Register'
import { RootState, useAppSelector } from '../../store'
import Loading from '../layouts/Loading'
import ServerNotice from '../server-notice'
import { useIsDocumentLoaded } from '../../hooks/useIsDocumentLoaded'

interface Auth {
  authRoute: string
}

const Auth: React.FC<Auth> = ({ authRoute }) => {
  const navigate = useNavigate()
  const user = useAppSelector((state: RootState) => state.user)
  const { loading } = useAppSelector(s => s.user)
  const isLoaded = useIsDocumentLoaded()

  useEffect(() => {
    if (user.user !== null && user.isAuthenticated) {
      navigate('/')
    }
  }, [user])
  // const handleLoading = (ok:boolean) => setLoading(ok)
  return (
    <>
      <ServerNotice open={isLoaded} />
      <div className="login">
        <div className="main__login">
          <ToastContainer />
          {authRoute === 'login' && <Login />}
          {authRoute === 'register' && <Register />}
          <div className="r-l"></div>
        </div>
        {loading ? <Loading /> : null}
      </div>
    </>
  )
}

export default Auth
